import { render, staticRenderFns } from "./RemoveDocumentTypeFromChecklist.vue?vue&type=template&id=19510616&scoped=true&"
import script from "./RemoveDocumentTypeFromChecklist.vue?vue&type=script&lang=js&"
export * from "./RemoveDocumentTypeFromChecklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19510616",
  null
  
)

export default component.exports